import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router/index'
// api接口内容
import apiFun from "./assets/js/api";
//全局js
import method from "./assets/js/method";
import * as svgs from '@/libs/svgicon'

// 引入全局样式
import "../src/assets/css/common.css"
import "../src/assets/css/common.less"
//阿里图标
import "./assets/icon/iconfont.css";
//echarts
import * as echarts from 'echarts';

Vue.config.productionTip = false
Vue.config.devtools = false   // 关闭vue-devtools提示


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';  // 引入样式文件‌:ml-citation{ref="1,5" data="citationList"}  

Vue.use(ElementUI);
Vue.use(VueI18n);
// 加载语言资源
const messages = {
  en: require('./lang/en.json'),
  'zh-CN': require('./lang/zh-CN.json')
}

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: 'zh-CN',       // 默认语言
  fallbackLocale: 'en',  // 回退语言
  messages
})

// 公共組件
import NavHeader from './components/NavHeader.vue'
import NavHeader2 from './components/NavHeader2.vue'
import NavFooter from './components/NavFooter.vue'
import Sidebar from './components/SideBar.vue'
import MapContainer from './components/MapContainer/MapContainer.vue'
import MapIndex from './components/MapContainer/MapIndex.vue'
import Tagnav from './components/Tagnav.vue'
import CustomTabs from './components/CustomTabs.vue'
import CustomTable from './components/CustomTable.vue'
import CustomPagination from './components/CustomPagination.vue'
import CustomDrawer from './components/CustomDrawer.vue'
import SystemSettingItem from './components/SystemSettingItem.vue'
import CustomDialog from './components/CustomDialog.vue'
import CustomForm from './components/CustomForm.vue'
import SvgIcon from '@/components/SvgIcon'
Vue.component('side-bar', Sidebar)
Vue.component('nav-header', NavHeader)
Vue.component('nav-header2', NavHeader2)
Vue.component('nav-footer', NavFooter)
Vue.component('gd-map', MapContainer)
Vue.component('index-map', MapIndex)
Vue.component('tag-nav', Tagnav)
Vue.component('custom-tabs', CustomTabs)
Vue.component('custom-table', CustomTable)
Vue.component('custom-pagination', CustomPagination)
Vue.component('custom-drawer', CustomDrawer)
Vue.component('system-setting-item', SystemSettingItem)
Vue.component('custom-dialog', CustomDialog)
Vue.component('custom-form', CustomForm)
Vue.component('svg-icon', SvgIcon)

Vue.prototype.$apiFun = apiFun; //请求接口 api
Vue.prototype.$js = method; //公共工具类
// Vue.prototype.$echarts = echarts  //echarts
Vue.prototype.$svgs = svgs


new Vue({
  i18n,
  router: router,
  render: h => h(App),
}).$mount('#app')
